import liquidChromeDrip from '../assets/liquid-chrome-drip.jpg';
import hotpinkPicnicMix from '../assets/hotpink-picnic-mix.jpg';
import cosmicSplash from '../assets/cosmic-splash.jpg';
import rubyGlass from '../assets/ruby-glass.jpg';
import neonPopMix from '../assets/neon-pop-mix.jpg';
import zebraIllusion from '../assets/zebra-illusion.jpg';
import galaxyDots from '../assets/galaxy-dots.jpg';
import roseAmethyst from '../assets/rose-amethyst.jpg';
import gildedWaves from '../assets/gilded-waves.jpg'
import elementalFusion from '../assets/elemental-fusion.jpg'
import rubyRelic from '../assets/ruby-relic.jpg'
import cuEspressoShortSq from '../assets/custom-espresso-short-square.JPG';
import colorfullyGilded from '../assets/colorfully-gilded.jpg'
import pinkSunrise from '../assets/pink-sunrise.JPG'
import bloodyShoesShort from '../assets/celeb-inspired-cardi-b-bloddy-bottom-short-square.JPG'
import genderReveal from '../assets/celeb-inspired-cardi-b-gender-reveal-medium-square.JPG'
import slimeGreen from '../assets/custom-slime-green-xshort-squareJPG.JPG'
import cannabae from '../assets/custom-canna-bae-medium-coffin.JPG'


const signatureSets = [
  {
    id: 'sig-elemental-fusion',
    slug: 'sig-elemental-fusion',
    title: 'Elemental Fusion',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: elementalFusion,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  
  },
  {
    id: 'sig-gender-reveal',
    slug: 'sig-gender-reveal',
    title: 'Gender Reveal',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: genderReveal,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
    tags: ['celeb-inspired'],        
    featured: true  
  },
  {
    id: 'sig-colorfully-gilded',
    slug: 'sig-colorfully-gilded',
    title: 'Colorfully Gilded',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: colorfullyGilded,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-canna-bae',
    slug: 'sig-canna-bae',
    title: 'Canna Bae',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: cannabae,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-bloody-shoes',
    slug: 'sig-bloody-shoes',
    title: 'Bloody Shoes',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: bloodyShoesShort,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
    tags: ['celeb-inspired'],        
    featured: true  
  },
  {
    id: 'sig-pink-sunrise',
    slug: 'sig-pink-sunrise',
    title: 'Pink Sunrise',
    tier: "NeNe Nail’d It Again",
    priceCents: 5500,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: pinkSunrise,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-liquid-chrome-drip',
    slug: 'sig-liquid-chrome-drip',
    title: 'Liquid Chrome Drip',
    tier: "NeNe Nail’d It Again",
    priceCents: 5500,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: liquidChromeDrip,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-ruby-glass',
    slug: 'sig-ruby-glass',
    title: 'Ruby Glass',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: rubyGlass,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
      id: 'sig-espresso-short-square',
      slug: 'sig-espresso-short-square',
      title: 'Safari Realness',
      tier: "NeNe Nail’d It Again",
      priceCents: 5500,
      options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
      thumbnail: cuEspressoShortSq,
      inventory: { trackType: 'made_to_order' },
      isSignature: true,
    },
  {
    id: 'sig-ruby-relic',
    slug: 'sig-ruby-reli',
    title: 'Ruby Relic',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: rubyRelic,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-neon-pop-mix',
    slug: 'sig-neon-pop-mix',
    title: 'Neon Pop Mix',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: neonPopMix,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-zebra-illusion',
    slug: 'sig-zebra-illusion',
    title: 'Zebra Illusion',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: zebraIllusion,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-galaxy-dots',
    slug: 'sig-galaxy-dots',
    title: 'Galaxy Dots',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: galaxyDots,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-gilded-waves',
    slug: 'sig-gilded-waves',
    title: 'Gildes Waves',
    tier: "NeNe Nail’d It Again",
    priceCents: 5500,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: gildedWaves,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-hotpink-picnic-mix',
    slug: 'sig-hotpink-picnic-mix',
    title: 'Hotpink Picnic Mix',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: hotpinkPicnicMix,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-cosmic-splash',
    slug: 'sig-cosmic-splash',
    title: 'Cosmic Splash',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: cosmicSplash,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
  {
    id: 'sig-rose-amethyst',
    slug: 'sig-rose-amethyst',
    title: 'Rose Amethyst',
    tier: "NeNe Nail’d It Again",
    priceCents: 6600,
    options: { shape: ['Square','Almondetto','Coffin'], length: ['Short','Medium','Long'] },
    thumbnail: roseAmethyst,
    inventory: { trackType: 'made_to_order' },
    isSignature: true,
  },
];

export default signatureSets;
